module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1hsXmipyCiac2uMQSquEgw-3b6740ccaf69f727cfe6159d02da2d6c.jpg";